// credit: https://stackoverflow.com/a/15638147/7562739

export const urlCleanDuplicateSlash = (url = '') => url.replace(/([^:]\/)\/+/g, '$1')
